import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getParents = params => {
  return api.get(`admin/parent`, {
    params,
  });
};

export const getParentsQueryOptions = params => {
  return queryOptions({
    queryKey: ["parents", params],
    queryFn: () => getParents(params),
  });
};

export const useParentsQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getParentsQueryOptions(params),
    ...queryConfig,
  });
}; 